module.exports = __webpack_public_path__ + "static/media/no-debts.c4835a99.svg";